import React, { useEffect, useState, useRef } from "react";
import { FaUserCircle, } from "react-icons/fa";
import { IoMdAdd } from "react-icons/io";
import { MdKeyboardArrowDown } from 'react-icons/md';
import { AiFillCodepenCircle } from "react-icons/ai";
import { FaChevronDown, FaChevronUp, FaRocket } from 'react-icons/fa';
import { IoLink, IoClose } from "react-icons/io5";
import { DataState } from "../../context/DataProvider";
import { getJiraIssueDetails, updateJiraIssue, fetchJiraUsers, fetchJiraIssues } from "../../services/api";
import { toast } from "react-hot-toast";
import { BiSolidEdit } from "react-icons/bi";
import { HiLightningBolt } from "react-icons/hi";
import JiraIssueActivity from "./JiraIssueActivity";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";


const SkeletonLoader = ({ type = 'text' }) => {
  if (type === 'text') {
    return (
      <div className="mr-4 space-y-4">
        <div className="w-full h-6 bg-gray-300 animate-pulse rounded"></div>
        <div className="w-3/4 h-6 bg-gray-300 animate-pulse rounded"></div>
        <div className="w-1/2 h-6 bg-gray-300 animate-pulse rounded"></div>
      </div>
    );
  }
  if (type === 'description') {
    return (
      <div className="mr-4 space-y-4">
        <div className="w-full h-3 bg-gray-300 animate-pulse rounded"></div>
        <div className="w-3/4 h-3 bg-gray-300 animate-pulse rounded"></div>
        <div className="w-1/2 h-3 bg-gray-300 animate-pulse rounded"></div>
        <div className="w-3/4 h-3 bg-gray-300 animate-pulse rounded"></div>
        <div className="w-1/2 h-3 bg-gray-300 animate-pulse rounded"></div>
      </div>
    );
  }

  if (type === 'image') {
    return (
      <div className="mr-4 w-full h-48 bg-gray-300 animate-pulse rounded-lg"></div>
    );
  }

  if (type === 'card') {
    return (
      <div className="mr-4 w-full max-w-sm bg-white shadow-md rounded-lg p-4 space-y-4">
        <div className="w-full h-32 bg-gray-300 animate-pulse rounded-lg"></div>
        <div className="h-6 bg-gray-300 animate-pulse rounded"></div>
        <div className="h-6 w-3/4 bg-gray-300 animate-pulse rounded"></div>
      </div>
    );
  }

  return null;
};

function convertToIST(dateString) {
  // Parse the date string into a Date object (in UTC)
  const dateUTC = new Date(dateString);

  // Format the date to "28 Jan, 2025"
  const formattedDate = dateUTC.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return formattedDate;
}

const modules = {
  toolbar: [
    [{ font: [] }, { size: [] }], // Font and Size
    ["bold", "italic", "underline", "strike"], // Formatting
    [{ color: [] }, { background: [] }], // Text color & Background color
    [{ list: "ordered" }, { list: "bullet" }], // Ordered & Unordered lists
    [{ align: [] }], // Alignment options
    ["blockquote"], // Blockquote & Code block
    ["link", "image"], // Links & Images
    ["clean"], // Remove formatting
  ],
};

const formats = [
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "list",
  "bullet",
  "align",
  "blockquote",
  "link",
  "image",
  "clean",
];


const JiraIssueModal = ({ issue_key, onClose }) => {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [isAutomationOpen, setIsAutomationOpen] = useState(false);
  const [issue, setIssue] = useState({});
  const {
    userGoogleId
  } = DataState();

  const [isEditing, setIsEditing] = useState(false);
  const [isAssigneeEditing, setIsAssigneeEditing] = useState(false);
  const [updatedIssue, setUpdatedIssue] = useState(issue);
  const [allAssignees, setAllAssignees] = useState([]);
  const [assigneeQuery, setAssigneeQuery] = useState("");
  const [assigneeOptions, setAssigneeOptions] = useState([]);
  const [selectedAssignee, setSelectedAssignee] = useState(issue?.fields?.assignee || null);
  const [loading, setLoading] = useState(true);
  const [saveLoading, setSaveLoading] = useState(false);


  const toggleDetails = () => setIsDetailsOpen(!isDetailsOpen);
  const toggleAutomation = () => setIsAutomationOpen(!isAutomationOpen);
  const [avatarUrl, setAvatarUrl] = useState(null);
  const [issuesforparentkey, setIssuesForParentKey] = useState([]);
  const [filteredIssues, setFilteredIssues] = useState([]);

  const [selectedParentKey, setSelectedParentKey] = useState(updatedIssue?.fields?.parent?.key || "");
  const [showDropdown, setShowDropdown] = useState(false);
  const previousDescriptionRef = useRef(updatedIssue?.fields?.description);


  useEffect(() => {
    const assigneeId = selectedAssignee
      ? selectedAssignee.accountId
      : issue?.fields?.assignee?.accountId;

    if (assigneeId) {
      const assignee = allAssignees.find(user => user.accountId === assigneeId);
      setAvatarUrl(assignee ? assignee.avatarUrls["16x16"] : null);
    } else {
      setAvatarUrl(null);
    }
  }, [selectedAssignee, issue, allAssignees]);

  const setIssueDetails = async () => {
    if (!issue_key) {
      return;
    }

    try {
      let message_data = null;

      message_data = await getJiraIssueDetails(issue_key, userGoogleId);


      console.log("Issue Data After Update:", message_data)
      setIssue(message_data)
      setLoading(false)


    } catch (error) {
      console.log("Error while fecthing message details:", error);
      toast.error(error);
      setLoading(false)

    }
  }

  useEffect(() => {
    setIssueDetails();
  }, [issue_key])

  useEffect(() => {
    const getIssues = async () => {
      try {
        const issues = await fetchJiraIssues('KAN', userGoogleId);
        setIssuesForParentKey(issues);
        console.log('Fetched Jira Issues:', issuesforparentkey);
      } catch (error) {
        console.error('Failed to fetch Jira Issues:', error);
      }
    };
    getIssues();

  }, [issue_key])
  useEffect(() => {
    console.log('Fetched Jira Issues:', issuesforparentkey);

  }, [issuesforparentkey])

  useEffect(() => {
    setUpdatedIssue(issue);
    const isEpic = issue?.fields?.issuetype?.name?.toLowerCase() === "epic";

  }, [issue])


  const visitIssue = (issueLink) => {
    // const issueLink = "https://example.com"; 
    window.open(issueLink, "_blank");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log("name is", name);
    console.log("value is", value);


    setUpdatedIssue((prev) => ({
      ...prev,
      fields: {
        ...prev.fields,

        // Ensure status exists before updating status.name
        status: {
          ...prev.fields?.status,  // Keep existing status properties
          name: name === "status" ? value : prev.fields?.status?.name, // Only update name
        },

        // Update other fields normally
        ...(name !== "status" && { [name]: value }),
      },
    }));

    console.log("Updated Issue:", updatedIssue);
  };

  function htmlToJira(html) {
    if (!html) return "";

    return html
      .replace(/<b>(.*?)<\/b>/g, '*$1*') // Bold
      .replace(/<strong>(.*?)<\/strong>/g, '*$1*') // Strong as Bold
      .replace(/<i>(.*?)<\/i>/g, '_$1_') // Italics
      .replace(/<em>(.*?)<\/em>/g, '_$1_') // Emphasis as Italics
      .replace(/<strike>(.*?)<\/strike>/g, '-$1-') // Strikethrough
      .replace(/<del>(.*?)<\/del>/g, '-$1-') // Deleted text as Strikethrough
      .replace(/<code>(.*?)<\/code>/g, '{{ $1 }}') // Inline code
      .replace(/<pre>(.*?)<\/pre>/gs, '{code}$1{code}') // Code Block
      .replace(/<a href="(.*?)">(.*?)<\/a>/g, '[$2|$1]') // Links
      .replace(/<ul>(.*?)<\/ul>/gs, (match, content) => content.replace(/<li>(.*?)<\/li>/g, '* $1')) // Bullet List
      .replace(/<ol>(.*?)<\/ol>/gs, (match, content) => content.replace(/<li>(.*?)<\/li>/g, '# $1')) // Numbered List
      .replace(/<h1>(.*?)<\/h1>/g, 'h1. $1') // Headings
      .replace(/<h2>(.*?)<\/h2>/g, 'h2. $1')
      .replace(/<h3>(.*?)<\/h3>/g, 'h3. $1')
      .replace(/<h4>(.*?)<\/h4>/g, 'h4. $1')
      .replace(/<h5>(.*?)<\/h5>/g, 'h5. $1')
      .replace(/<h6>(.*?)<\/h6>/g, 'h6. $1')
      .replace(/<p>(.*?)<\/p>/g, '$1\n') // Paragraphs
      .replace(/<br\s*\/?>/g, '\n') // Line Breaks
      .replace(/\{color:([^}]+)\}(.*?)\{color\}/g, '<span style="color:$1;">$2</span>') // Color
      .replace(/<table>(.*?)<\/table>/gs, (match, content) =>
        content
          .replace(/<tr>/g, '|')
          .replace(/<\/tr>/g, '|\n')
          .replace(/<td>(.*?)<\/td>/g, '| $1 ')
          .replace(/<th>(.*?)<\/th>/g, '|| $1 ')
      ); // Tables
  }


  //handleInputChange for react quill input box
  const handleQuillChange = (content, name) => {
    console.log("Updating description:", content);
    // const jiratext = htmlToJira(content);
    // console.log("Updating jiratext:", jiratext);

    // if (jiratext !== previousDescriptionRef.current) {
    //   previousDescriptionRef.current = jiratext;

    // }
    setUpdatedIssue((prev) => ({
      ...prev,
      fields: {
        ...prev.fields,
        [name]: content,
      },
    }));
  };

  useEffect(() => {
    if (selectedParentKey.trim()) {
      const filtered = issuesforparentkey.filter((i) =>
        i.issuetype.toLowerCase() === "epic" && // Exclude Epics from selection
        i.key.toLowerCase().includes(selectedParentKey.toLowerCase()) // Match typed input
      );
      setFilteredIssues(filtered);
    } else {
      setFilteredIssues([]);
    }
  }, [selectedParentKey, issuesforparentkey]);




  useEffect(() => {
    console.log("updatedIssue after input change: ", updatedIssue);
  }, [updatedIssue]);

  const handleUpdateIssue = async () => {
    setSaveLoading(true);
    try {
      const updatedFields = {
        summary: updatedIssue?.fields?.summary,
        description: updatedIssue?.fields?.description,
        issue_type: updatedIssue?.fields?.issuetype?.name,
        assignee_id: updatedIssue?.fields?.assignee?.accountId,
        duedate: updatedIssue?.fields?.duedate,
        parent_issue_key: updatedIssue?.fields?.parent?.key,
        status: updatedIssue?.fields?.status?.name
      };

      console.log("Updating Issue with:", updatedFields);

      await updateJiraIssue(issue_key, updatedFields, userGoogleId);
      toast.success("Issue updated successfully!");

      setIsEditing(false);
      setIssue(updatedIssue);
      
    } catch (error) {
      console.error("Error updating issue:", error);
      toast.error("Failed to update the issue.");
    } finally {
      setSaveLoading(false);
    }
  };

  useEffect(() => {
    const fetchAllAssignees = async () => {
      try {
        const data = await fetchJiraUsers("", userGoogleId); // Fetch all users without filtering
        setAllAssignees(data.users || []);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchAllAssignees();
  }, [userGoogleId]);

  useEffect(() => {
    if (assigneeQuery.length >= 1) {
      const filteredUsers = allAssignees.filter((user) =>
        user.displayName.toLowerCase().includes(assigneeQuery.toLowerCase())
      );
      setAssigneeOptions(filteredUsers);
    } else {
      setAssigneeOptions([]);
    }
  }, [assigneeQuery, allAssignees]);

  const handleSelectAssignee = (user) => {
    setSelectedAssignee(user);
    setAssigneeQuery(user.displayName);
    setAssigneeOptions([]);
    setIsAssigneeEditing(false);

    setUpdatedIssue((prev) => ({
      ...prev,
      fields: {
        ...prev.fields,
        assignee: {
          ...prev.fields?.assignee,  // Preserve other assignee fields
          accountId: user.accountId,  // Update the selected assignee ID
        }
      }
    }));
  };

  const stripHtmlTags = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  return (
    <div
      className="fixed inset-0 flex z-50 backdrop-blur-sm items-center justify-center bg-black bg-opacity-50"
      onClick={onClose}
    >

      <div
        className="flex flex-col bg-white w-full max-sm:h-full sm:w-[65%] p-6 sm:rounded-xl shadow-xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex sm:pr-4 sm:pl-4 items-center justify-between w-full">
          <div className="flex text-sm text-gray-600 mb-2 items-center">
            {loading ? (
              <div className="w-96 h-4 bg-gray-300 animate-pulse rounded" />
            ) : (
              <>
                {issue?.fields?.parent && (
                  <>
                    <img
                      key={issue?.fields?.parent?.fields?.issuetype?.name}
                      src={`/assets/jiraissuetable/jiraIssueTypeIcons/${issue?.fields?.parent.fields?.issuetype?.name.toLowerCase()}.png`}
                      alt={`${issue?.fields?.parent.fields?.issuetype?.name} Icon`}
                      className="w-4 h-4 mr-1"
                      onError={(e) => (e.target.style.display = "none")}
                    />
                    {issue?.fields?.parent?.key} /
                  </>
                )}

                <img
                  key={issue?.fields?.issuetype?.name}
                  src={`/assets/jiraissuetable/jiraIssueTypeIcons/${issue?.fields?.issuetype?.name.toLowerCase()}.png`}
                  alt={`${issue?.fields?.issuetype?.name} Icon`}
                  className="w-4 h-4 mx-1"
                  onError={(e) => (e.target.style.display = "none")}
                />

                {issue?.key}
              </>
            )}
          </div>
          <div className="flex items-center justify-center gap-4">
            {!isEditing && <div>
              <button
                className="text-gray-500 hover:text-gray-800"
                onClick={() => { setIsEditing(!isEditing); setIsAssigneeEditing(true) }}
              >
                <BiSolidEdit size={20} />
              </button>
            </div>
            }
            <div>
              <button onClick={() => visitIssue(issue?.fields?.issue_url)} className="text-gray-500 hover:text-gray-800">
                <IoLink size={20} />
              </button>
            </div>
            <div>
              <button onClick={onClose} className="text-gray-500 hover:text-gray-800">
                <IoClose size={20} />
              </button>
            </div>

          </div>
        </div>
        <div className="flex gap-4">
          <div className="w-full max-sm:pt-4 sm:p-4 sm:pr-0 sm:w-[60%]">
            {/* Header */}
            <div className="flex flex-col justify-between items-center border-b pb-4 mb-4">

              <div className="flex w-full text-xl text-gray-800 font-semibold">
                {loading ? (
                  <div className="w-full h-6 bg-gray-300 animate-pulse rounded" />
                ) : isEditing ? (
                  <input
                    type="text"
                    name="summary"
                    value={updatedIssue?.fields?.summary || ""}
                    onChange={handleInputChange}
                    className="w-full p-2 text-xl border border-gray-300 text-gray-800 font-semibold  rounded-md focus:outline-none focus:ring-0"
                  />
                ) : (
                  <span>{issue?.fields?.summary}</span>
                )}
              </div>

            </div>

            {/* Details */}
            <div className="flex gap-1 mb-6">
              {loading ? (
                <>
                  <div className="w-24 h-8 bg-gray-300 animate-pulse rounded-md" />
                  <div className="w-24 h-8 bg-gray-300 animate-pulse rounded-md" />
                  <div className="w-24 h-8 bg-gray-300 animate-pulse rounded-md" />
                </>
              ) : isEditing ? (
                <>
                  <select
                    name="status"
                    value={updatedIssue?.fields?.status?.name || ""}
                    onChange={handleInputChange}
                    className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md text-sm flex items-center"
                  >
                    <option value="To Do">To Do</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Done">Done</option>
                  </select>
                  <button className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md text-sm flex items-center">
                    <IoMdAdd className="mr-1" /> Add
                  </button>
                  <button className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md text-sm flex items-center">
                    <AiFillCodepenCircle className="mr-1" /> Apps
                  </button>
                </>
              ) : (
                <>
                  <button className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md text-sm flex items-center">
                    {issue?.fields?.status?.name} <MdKeyboardArrowDown className="ml-1" />
                  </button>
                  <button className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md text-sm flex items-center">
                    <IoMdAdd className="mr-1" /> Add
                  </button>
                  <button className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md text-sm flex items-center">
                    <AiFillCodepenCircle className="mr-1" /> Apps
                  </button>
                </>
              )

              }
            </div>
            <div className="flex-1 max-h-[600px] sm:max-h-[400px] overflow-y-auto hide-sidebar">
              <div className="overflow-hidden">

                {/* Description */}
                <div className="mb-6 mr-2">
                  <h3 className="text-sm font-semibold text-gray-700">Description</h3>
                  <div className="text-sm text-gray-600 mt-2 whitespace-pre-line">
                    {loading ? (
                      <SkeletonLoader type="description" />
                    ) : isEditing ? (
                     
                      // <ReactQuill
                      //   value={updatedIssue?.fields?.description || ""}
                      //   onChange={(content) => handleQuillChange(content, "description")}
                      //   modules={modules}
                      //   formats={formats}
                      //   className="w-full text-gray-600 text-md"
                      // />
                      <textarea
                        id="textarea"
                        rows="6"
                        value={stripHtmlTags(updatedIssue?.fields?.description || "")}
                        name="description"
                        onChange={handleInputChange}
                        className="w-full p-3 text-sm text-gray-800 border border-gray-300 hide-sidebar rounded-lg focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400 resize-none"
                      ></textarea>
                    ) : (
                      issue?.fields?.description ? (
                        <div dangerouslySetInnerHTML={{ __html: issue.fields.description }} />
                      ) : (
                        <em className="italic">No description</em>
                      )
                    )}
                  </div>
                </div>

                <div className="sm:hidden block bg-white rounded-lg pt-4 w-full">
                  {/* Actions Section */}
                  <div className="flex items-center mb-2">
                    <h3 className="flex items-center justify-center font-semibold text-gray-800"><HiLightningBolt /> Actions</h3>
                    <button className="text-gray-500 ml-1">
                      <FaChevronDown />
                    </button>
                  </div>

                  {/* Details Section */}
                  <div>
                    <div className="flex items-center justify-between cursor-pointer px-4 py-2 border border-gray-300" onClick={toggleDetails}>
                      <h4 className="font-medium text-gray-700">Details</h4>
                      <button className="text-gray-500">
                        {isDetailsOpen ? <FaChevronUp /> : <FaChevronDown />}
                      </button>
                    </div>
                    {isDetailsOpen && (
                      <div className="space-y-2 px-4 py-2 text-gray-700 border-t-0 border text-sm border-gray-300 ">
                        <div className="grid grid-cols-2 items-center py-2 ">
                          <div className="flex items-center">

                            <span className="ml-2">Assignee</span>
                          </div>
                          <div>
                            {(isEditing && isAssigneeEditing) ? (
                              <div className="relative">
                                <input
                                  type="text"
                                  value={assigneeQuery}
                                  onChange={(e) => setAssigneeQuery(e.target.value)}
                                  onBlur={() => setTimeout(() => setAssigneeOptions([]), 200)}
                                  placeholder="Search assignee..."
                                  className="border rounded p-2 w-full focus:outline-none resize-none"
                                />
                                {assigneeOptions.length > 0 && (
                                  <ul className="absolute bg-white border z-10 rounded shadow-md max-h-40 overflow-y-auto scrollbar-thin scrollbar-track-gray-200 scrollbar-thumb-gray-500 w-full">
                                    {assigneeOptions.map((user) => (
                                      <li
                                        key={user.accountId}
                                        className="p-2 cursor-pointer hover:bg-gray-200 text-sm flex items-center"
                                        onClick={() => handleSelectAssignee(user)}
                                      >
                                        <img
                                          src={user.avatarUrls["16x16"]}
                                          alt={user.displayName}
                                          className="mr-2 h-7 w- rounded-full"
                                        />
                                        {user.displayName}
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </div>
                            ) : (
                              <div>
                                {(selectedAssignee || issue?.fields?.assignee) ? (
                                  <div
                                    onClick={() => setIsAssigneeEditing(true)}
                                    className="flex items-center cursor-pointer"
                                  >
                                    {avatarUrl && (
                                      <img
                                        src={avatarUrl}
                                        alt={(selectedAssignee || issue.fields.assignee).displayName}
                                        className="mr-2 h-7 w-7 rounded-full"
                                      />
                                    )}
                                    {(selectedAssignee || issue.fields.assignee).displayName}
                                  </div>
                                ) : (
                                  <span className="text-gray-500 italic">Unassigned</span>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="grid grid-cols-2 items-center py-2 ">
                          <div className="flex items-center">
                            <span className="ml-2">Labels</span>
                          </div>
                          <div className="flex flex-wrap gap-2">
                            {issue?.fields?.labels && issue?.fields?.labels.length > 0 ? (
                              issue?.fields?.labels.map((label) => (
                                <span key={label} className="px-2 py-1  bg-zinc-300 text-gray-600 rounded-lg text-xs font-medium">
                                  {label}
                                </span>
                              ))
                            ) : (
                              <span className="px-3 py-1 bg-gray-400 text-white rounded-lg text-sm font-medium">None</span>
                            )}
                          </div>
                        </div>
                        {!(issue?.fields?.issuetype?.name?.toLowerCase() === "epic") && (<div className="grid grid-cols-2 items-center py-2 ">
                          <div className="flex items-center">
                            <span className="ml-2">Parent</span>
                          </div>
                          {loading ? (
                            <div className="w-full h-6 bg-gray-300 animate-pulse rounded" />
                          ) : isEditing ? (
                            <div className="relative w-full">
                              <input
                                type="text"
                                name="parentKey"
                                value={selectedParentKey}
                                onChange={(e) => {
                                  setSelectedParentKey(e.target.value);
                                  setShowDropdown(true);
                                }}
                                autoComplete="off"
                                onFocus={() => setShowDropdown(true)}
                                onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                                className="w-full p-1 text-sm border border-gray-300 text-gray-800 font-semibold rounded-md focus:outline-none focus:ring-0"
                              />

                              {showDropdown && filteredIssues.length > 0 && (
                                <ul className="absolute left-0 z-10 bg-white border rounded shadow-md max-h-40 overflow-y-auto scrollbar-thin scrollbar-track-gray-200 scrollbar-thumb-gray-500 w-full ">
                                  {filteredIssues.map((issueItem) => (
                                    <li
                                      key={issueItem.key}
                                      className="p-2 cursor-pointer hover:bg-gray-200 text-sm flex items-center"
                                      onMouseDown={(e) => {
                                        setSelectedParentKey(issueItem.key);
                                        setShowDropdown(false);

                                        setUpdatedIssue((prevIssue) => ({
                                          ...prevIssue,
                                          fields: {
                                            ...prevIssue.fields,
                                            parent: {
                                              ...prevIssue.fields?.parent,
                                              key: issueItem.key, // Update the parent key inside fields
                                            },
                                          },
                                        }));
                                      }}
                                    >
                                      {<img
                                        key={issueItem?.issuetype}
                                        src={`/assets/jiraissuetable/jiraIssueTypeIcons/${issueItem?.issuetype?.toLowerCase()}.png`}
                                        alt={`${issueItem?.issuetype} Icon`}
                                        className="w-4 h-4 mr-1"
                                        onError={(e) => (e.target.style.display = "none")}
                                      />}
                                      {issueItem.key}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          ) : (
                            <>
                              <div>{issue?.fields?.parent?.key || <span className="text-gray-500 italic">None</span>}</div>
                            </>
                          )}
                        </div>
                        )}

                        {/* Due Date */}
                        <div className="grid grid-cols-2 items-center py-2">
                          <div className="flex items-center">
                            <span className="ml-2">Due Date</span>
                          </div>
                          <div>
                            {
                              isEditing ? (
                                <input
                                  type="date"
                                  name="duedate"
                                  value={updatedIssue?.fields?.duedate || ""}
                                  onChange={handleInputChange}
                                  className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-0"
                                />
                              ) : issue?.fields?.duedate ? (
                                convertToIST(issue.fields.duedate)
                              ) : (
                                <span className="text-gray-500 italic">None</span>
                              )
                            }
                          </div>
                        </div>


                        {/* Reporter */}
                        <div className="grid grid-cols-2 items-center py-2 ">
                          <div className="flex items-center">

                            <span className="ml-2">Reporter</span>
                          </div>
                          <div>
                            {issue.fields?.reporter ? (
                              <div className="flex items-center">
                                <FaUserCircle className="mr-2 text-green-500" />
                                {issue.fields?.reporter?.displayName}
                              </div>
                            ) : (
                              <span className="text-gray-500 italic">No Reporter</span>
                            )}
                          </div>
                        </div>

                      </div>
                    )}
                  </div>

                  {/* Automation Section */}
                  <div className="mt-4">
                    <div className="flex items-center justify-between cursor-pointer px-4 py-2 border border-gray-300" onClick={toggleAutomation}>
                      <h4 className="font-medium text-gray-700">Automation</h4>
                      <button className="text-gray-500">
                        {isAutomationOpen ? <FaChevronUp /> : <FaChevronDown />}
                      </button>
                    </div>
                    {isAutomationOpen && (
                      <div className="space-y-2 text-gray-700  px-4 py-2 border-t-0 border border-gray-300">
                        <div className="flex items-center">
                          <FaRocket className="text-gray-500" />
                          <span className="ml-2">Rule executions</span>
                        </div>
                        {/* Add more dummy fields here */}
                        <div className="flex items-center">
                          <FaRocket className="text-gray-500" />
                          <span className="ml-2">Dummy field 1</span>
                        </div>
                        <div className="flex items-center">
                          <FaRocket className="text-gray-500" />
                          <span className="ml-2">Dummy field 2</span>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Created and Updated Section */}
                  <div className="mt-4 text-gray-600 text-sm">
                    <p>Created {new Date(issue?.fields?.created).toLocaleString()}</p>
                    <p>Updated {new Date(issue?.fields?.updated).toLocaleString()}</p>
                  </div>
                </div>

                {/* Activity / comments */}
                <div className="mb-6 mr-2">
                  <JiraIssueActivity
                    issue_key={issue_key}
                    comments={issue?.fields?.comment?.comments}
                    allAssignees={allAssignees}
                    refreshIssue={setIssueDetails}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="hidden sm:block bg-white rounded-lg p-4 w-[40%] ">
            {/* Actions Section */}
            <div className="flex items-center mb-2">
              <h3 className="flex items-center justify-center font-semibold text-gray-800"><HiLightningBolt /> Actions</h3>
              <button className="text-gray-500 ml-1">
                <FaChevronDown />
              </button>
            </div>

            {/* Details Section */}
            <div>
              <div className="flex items-center justify-between cursor-pointer px-4 py-2 border border-gray-300" onClick={toggleDetails}>
                <h4 className="font-medium text-gray-700">Details</h4>
                <button className="text-gray-500">
                  {isDetailsOpen ? <FaChevronUp /> : <FaChevronDown />}
                </button>
              </div>
              {isDetailsOpen && (
                <div className="space-y-2 px-4 py-2 text-gray-700 border-t-0 border text-sm border-gray-300 ">
                  <div className="grid grid-cols-2 items-center py-2 ">
                    <div className="flex items-center">

                      <span className="ml-2">Assignee</span>
                    </div>
                    <div>
                      {(isEditing && isAssigneeEditing) ? (
                        <div className="relative">
                          <input
                            type="text"
                            value={assigneeQuery}
                            onChange={(e) => setAssigneeQuery(e.target.value)}
                            onBlur={() => setTimeout(() => setAssigneeOptions([]), 200)}
                            placeholder="Search assignee..."
                            className="border rounded p-2 w-full focus:outline-none resize-none"
                          />
                          {assigneeOptions.length > 0 && (
                            <ul className="absolute bg-white border z-10 rounded shadow-md max-h-40 overflow-y-auto scrollbar-thin scrollbar-track-gray-200 scrollbar-thumb-gray-500 w-full">
                              {assigneeOptions.map((user) => (
                                <li
                                  key={user.accountId}
                                  className="p-2 cursor-pointer hover:bg-gray-200 text-sm flex items-center"
                                  onClick={() => handleSelectAssignee(user)}
                                >
                                  <img
                                    src={user.avatarUrls["16x16"]}
                                    alt={user.displayName}
                                    className="mr-2 h-7 w- rounded-full"
                                  />
                                  {user.displayName}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ) : (
                        <div>
                          {(selectedAssignee || issue?.fields?.assignee) ? (
                            <div
                              onClick={() => setIsAssigneeEditing(true)}
                              className="flex items-center cursor-pointer"
                            >
                              {avatarUrl && (
                                <img
                                  src={avatarUrl}
                                  alt={(selectedAssignee || issue.fields.assignee).displayName}
                                  className="mr-2 h-7 w-7 rounded-full"
                                />
                              )}
                              {(selectedAssignee || issue.fields.assignee).displayName}
                            </div>
                          ) : (
                            <span className="text-gray-500 italic">Unassigned</span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-2 items-center py-2 ">
                    <div className="flex items-center">
                      <span className="ml-2">Labels</span>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {issue?.fields?.labels && issue?.fields?.labels.length > 0 ? (
                        issue?.fields?.labels.map((label) => (
                          <span key={label} className="px-2 py-1  bg-zinc-300 text-gray-600 rounded-lg text-xs font-medium">
                            {label}
                          </span>
                        ))
                      ) : (
                        <span className="px-3 py-1 bg-gray-400 text-white rounded-lg text-sm font-medium">None</span>
                      )}
                    </div>
                  </div>
                  {!(issue?.fields?.issuetype?.name?.toLowerCase() === "epic") && (<div className="grid grid-cols-2 items-center py-2 ">
                    <div className="flex items-center">
                      <span className="ml-2">Parent</span>
                    </div>
                    {loading ? (
                      <div className="w-full h-6 bg-gray-300 animate-pulse rounded" />
                    ) : isEditing ? (
                      <div className="relative w-full">
                        <input
                          type="text"
                          name="parentKey"
                          value={selectedParentKey}
                          onChange={(e) => {
                            setSelectedParentKey(e.target.value);
                            setShowDropdown(true);
                          }}
                          autoComplete="off"
                          onFocus={() => setShowDropdown(true)}
                          onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                          className="w-full p-1 text-sm border border-gray-300 text-gray-800 font-semibold rounded-md focus:outline-none focus:ring-0"
                        />

                        {showDropdown && filteredIssues.length > 0 && (
                          <ul className="absolute left-0 z-10 bg-white border rounded shadow-md max-h-40 overflow-y-auto scrollbar-thin scrollbar-track-gray-200 scrollbar-thumb-gray-500 w-full ">
                            {filteredIssues.map((issueItem) => (
                              <li
                                key={issueItem.key}
                                className="p-2 cursor-pointer hover:bg-gray-200 text-sm flex items-center"
                                onMouseDown={(e) => {
                                  setSelectedParentKey(issueItem.key);
                                  setShowDropdown(false);

                                  setUpdatedIssue((prevIssue) => ({
                                    ...prevIssue,
                                    fields: {
                                      ...prevIssue.fields,
                                      parent: {
                                        ...prevIssue.fields?.parent,
                                        key: issueItem.key, // Update the parent key inside fields
                                      },
                                    },
                                  }));
                                }}
                              >
                                {<img
                                  key={issueItem?.issuetype}
                                  src={`/assets/jiraissuetable/jiraIssueTypeIcons/${issueItem?.issuetype?.toLowerCase()}.png`}
                                  alt={`${issueItem?.issuetype} Icon`}
                                  className="w-4 h-4 mr-1"
                                  onError={(e) => (e.target.style.display = "none")}
                                />}
                                {issueItem.key}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ) : (
                      <>
                        <div>{issue?.fields?.parent?.key || <span className="text-gray-500 italic">None</span>}</div>
                      </>
                    )}
                  </div>
                  )}

                  {/* Due Date */}
                  <div className="grid grid-cols-2 items-center py-2">
                    <div className="flex items-center">
                      <span className="ml-2">Due Date</span>
                    </div>
                    <div>
                      {
                        isEditing ? (
                          <input
                            type="date"
                            name="duedate"
                            value={updatedIssue?.fields?.duedate || ""}
                            onChange={handleInputChange}
                            className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-0"
                          />
                        ) : issue?.fields?.duedate ? (
                          convertToIST(issue.fields.duedate)
                        ) : (
                          <span className="text-gray-500 italic">None</span>
                        )
                      }
                    </div>
                  </div>


                  {/* Reporter */}
                  <div className="grid grid-cols-2 items-center py-2 ">
                    <div className="flex items-center">

                      <span className="ml-2">Reporter</span>
                    </div>
                    <div>
                      {issue.fields?.reporter ? (
                        <div className="flex items-center">
                          <FaUserCircle className="mr-2 text-green-500" />
                          {issue.fields?.reporter?.displayName}
                        </div>
                      ) : (
                        <span className="text-gray-500 italic">No Reporter</span>
                      )}
                    </div>
                  </div>

                </div>
              )}
            </div>

            {/* Automation Section */}
            <div className="mt-4">
              <div className="flex items-center justify-between cursor-pointer px-4 py-2 border border-gray-300" onClick={toggleAutomation}>
                <h4 className="font-medium text-gray-700">Automation</h4>
                <button className="text-gray-500">
                  {isAutomationOpen ? <FaChevronUp /> : <FaChevronDown />}
                </button>
              </div>
              {isAutomationOpen && (
                <div className="space-y-2 text-gray-700  px-4 py-2 border-t-0 border border-gray-300">
                  <div className="flex items-center">
                    <FaRocket className="text-gray-500" />
                    <span className="ml-2">Rule executions</span>
                  </div>
                  {/* Add more dummy fields here */}
                  <div className="flex items-center">
                    <FaRocket className="text-gray-500" />
                    <span className="ml-2">Dummy field 1</span>
                  </div>
                  <div className="flex items-center">
                    <FaRocket className="text-gray-500" />
                    <span className="ml-2">Dummy field 2</span>
                  </div>
                </div>
              )}
            </div>

            {/* Created and Updated Section */}
            <div className="mt-4 text-gray-600 text-sm">
              <p>Created {new Date(issue?.fields?.created).toLocaleString()}</p>
              <p>Updated {new Date(issue?.fields?.updated).toLocaleString()}</p>
            </div>
          </div>
        </div>

        {isEditing && (
          <div className="flex text-sm justify-end gap-4 mt-4">
            <button
              className="px-2 py-1 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
              onClick={() => setIsEditing(false)}
            >
              Cancel
            </button>
            <button
              disabled={saveLoading}
              className="px-2 py-1 bg-[#5652CF] text-white rounded-md hover:bg-blue-700"
              onClick={handleUpdateIssue}
            >
              {saveLoading ? "Saving...": "Save"}
            </button>
          </div>
        )}
      </div>





    </div>
  );
};

export default JiraIssueModal;